import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getCoupons() {
    yield takeEvery(actions.FETCH_COUPONS_REQUESTED, function* (action) {
        try {
          const coupons = yield call(actions.getCoupons, action.payload);
          yield put({ type: actions.FETCH_COUPONS_SUCCEEDED, coupons });
        } catch (error) {
          yield put({ type: actions.FETCH_COUPONS_FAILED, error: error.message });
        }
    });
}

export function* getCoupon() {
    yield takeEvery(actions.FETCH_COUPON_REQUESTED, function* (action) {
        try {
            const coupon = yield call(actions.getCoupon, action.payload);
            yield put({ type: actions.FETCH_COUPON_SUCCEEDED, coupon: coupon.coupon_info });
        } catch (error) {
            yield put({ type: actions.FETCH_COUPON_FAILED, error: error.message });
        }
    });
}

export function* deleteCoupon() {
  yield takeEvery(actions.DELETE_COUPON_REQUESTED, function* (action) {
      try {
          const coupon = yield call(actions.deleteCoupon, action.payload);
          yield put({ type: actions.DELETE_COUPON_SUCCEEDED, couponDeleted: coupon });
      } catch (error) {
          yield put({ type: actions.DELETE_COUPON_FAILED, error: error.message });
      }
  });
}


export default function* rootSaga() {
  yield all([
    fork(getCoupons),
    fork(getCoupon),
    fork(deleteCoupon)
  ]);
}
